import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AppFloatingConfigurator } from '../../layout/component/app.floatingconfigurator';

@Component({
    selector: 'app-notfound',
    standalone: true,
    imports: [RouterModule, AppFloatingConfigurator, ButtonModule],
    template: ` <app-floating-configurator />
        <div class="flex items-center justify-center min-h-screen overflow-hidden">
            <div class="flex flex-col items-center justify-center">
                <svg width="165" height="38.343" style="margin-bottom: 1rem;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165 38.343">
                    <g transform="translate(-192.662 -398.538)">
                        <g transform="translate(283.839 398.538)">
                            <path d="M305.921,428.649l13.742-23.8c.072-.121.139-.217.195-.294a2.422,2.422,0,0,1,.2.3l13.743,23.8h6.72L325.1,401.935a5.736,5.736,0,0,0-10.475,0L299.2,428.649Z" transform="translate(-299.199 -398.538)" fill="#7ab800" />
                        </g>
                        <g transform="translate(316.34 399.47)">
                            <path d="M371.776,399.628l-13.744,23.8a2.8,2.8,0,0,1-.195.3,2.782,2.782,0,0,1-.2-.3l-13.743-23.8h-6.72L352.6,426.342a5.736,5.736,0,0,0,10.475,0L378.5,399.628Z" transform="translate(-337.176 -399.628)" fill="#7ab800" />
                        </g>
                        <g transform="translate(192.662 398.671)">
                            <path
                                d="M198.483,437.037h-5.821V409.521a9.911,9.911,0,0,1,9.9-9.9h8.053a14.608,14.608,0,0,1,0,29.216h-8.538v-5.826h8.538a8.782,8.782,0,0,0,0-17.564h-8.053a4.081,4.081,0,0,0-4.075,4.078v27.516Z"
                                transform="translate(-192.662 -398.828)"
                                fill="#868686"
                            />
                            <g transform="translate(35.513 0.789)">
                                <path
                                    d="M259.588,402.722a14.5,14.5,0,0,0-9-3.1h-6.5a9.909,9.909,0,0,0-9.9,9.9V428.8h5.821V409.515a4.081,4.081,0,0,1,4.076-4.075h6.5a8.714,8.714,0,0,1,5.979,2.363A18.432,18.432,0,0,1,259.588,402.722Z"
                                    transform="translate(-234.193 -399.617)"
                                    fill="#868686"
                                />
                            </g>
                            <path
                                d="M279.622,429.48c-8.972,0-16.268-6.906-16.268-15.392s7.3-15.393,16.268-15.393,16.27,6.9,16.27,15.393-7.3,15.392-16.27,15.392Zm0-24.965c-5.76,0-10.446,4.294-10.446,9.573s4.686,9.573,10.446,9.573,10.448-4.3,10.448-9.573-4.688-9.573-10.448-9.573Z"
                                transform="translate(-202.906 -398.694)"
                                fill="#868686"
                            />
                        </g>
                    </g>
                </svg>
                <div style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, color-mix(in srgb, var(--primary-color), transparent 60%) 10%, var(--surface-ground) 30%)">
                    <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20 flex flex-col items-center" style="border-radius: 53px">
                        <span class="text-primary font-bold text-3xl">404</span>
                        <h1 class="text-surface-900 dark:text-surface-0 font-bold text-3xl lg:text-5xl mb-2">Sorry</h1>
                        <div class="text-surface-600 dark:text-surface-200 mb-2">Requested resource is not available.</div>
                        @if (attemptedRoute) {
                            <div class="text-surface-500 dark:text-surface-400 mb-8 font-mono text-sm">{{ attemptedRoute }}</div>
                        } @else {
                            <div class="mb-8"></div>
                        }
                        <p-button label="Go to Dashboard" routerLink="/" />
                    </div>
                </div>
            </div>
        </div>`
})
export class Notfound {
    private router = inject(Router);
    attemptedRoute: string;

    constructor() {
        this.attemptedRoute = this.router.url;
    }
}
